import { Provider } from '@angular/compiler/src/compiler_facade_interface';

export function getValidation(obj : Provider) : string{
    let validation = '';

    validation = getNameErrorMessage(obj);

    if(!validation){
        validation = getProviderErrorMessage(obj);
    }

    if(!validation){
        validation = getConnectionErrorMessage(obj);
    }

    return validation;
}

export function getNameErrorMessage(obj : Provider) {
    return !obj.Name ? 'Por favor, informe o nome' :
    '';
}

export function getProviderErrorMessage(obj : Provider) {
    return !isProviderTypeValid(obj.ProviderType) ? 'Por favor, selecione um provedor' : '';
}

export function getConnectionErrorMessage(obj : Provider) {
    return !obj.ConnectionString ? 'Por favor, informe a conexão' :
        '';
}

export function isProviderTypeValid(value : any) : boolean{
    return value || value === 0;
}
